var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "24px",
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 38") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "route",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(-14.000000, -8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(15.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    points: "0 2.37362637 8 -2.13162821e-13 16 3.16483516 24 0.791208791 24 19.7802198 16 22.1538462 8 18.989011 0 21.3626374"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    points: "4.62372371 8.27752821 8.40644799 12.9500915 12.8684681 10.1995634 17.3142824 14.9828761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30769231,5.91855204 C8.30769231,5.1998552 7.68669231,4.61538462 6.92307692,4.61538462 C6.15946154,4.61538462 5.53846154,5.1998552 5.53846154,5.91855204 C5.53846154,6.56296833 6.03853846,7.09813575 6.69230769,7.20217195 L6.69230769,8.30769231 L7.15384615,8.30769231 L7.15384615,7.20217195 C7.80761538,7.09813575 8.30769231,6.56296833 8.30769231,5.91855204 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2307692,15.1493213 C21.2307692,14.4306244 20.6097692,13.8461538 19.8461538,13.8461538 C19.0825385,13.8461538 18.4615385,14.4306244 18.4615385,15.1493213 C18.4615385,15.7937376 18.9616154,16.328905 19.6153846,16.4329412 L19.6153846,17.5384615 L20.0769231,17.5384615 L20.0769231,16.4329412 C20.7306923,16.328905 21.2307692,15.7937376 21.2307692,15.1493213 Z",
    id: "Path-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonActive);
export default __webpack_public_path__ + "static/media/button-active.1478cc5a048dc4e800edf91567dc435c.svg";
export { ForwardRef as ReactComponent };